/* 孫堅（字文台） */
import { defineHero, hook, S } from '../define.ts';

export default defineHero({
  id: 'sunjian', name: '孫堅', sub: '字文台', faction: 'wu', role: '戰士', weapon: 'sword',
  look: { wart: 'dao', weaponName: '古錠刀', head: 'hood', beard: 'mustache', eye: 'fierce', fx: '#ff6a4a', c: { hood: '#c4302a', armor: '#8f2a24' } },
  skills: [
    ['古錠刀', 'multi', '三連斬，每段 {60/98/136/174} 傷害。'],
    ['赤幘', 'stealth', '把赤幘留在原地當替身（3 秒，會吸引敵人攻擊），自己隱身 {2/2.5/3/3.5} 秒。', { x: { k: 'decoy', dur: [2, 2.5, 3, 3.5], life: 3 }, aim: S(0), el: 'shadow' }],
    ['江東猛虎', 'passive', '生命高於 70% 時，攻擊 +{8/12/16/20}。', { pv: {}, sig: 'tiger', atk: [8, 12, 16, 20] }],
    ['破虜', 'crescent', '揮出赤色刀氣，造成 {250/400/550} 傷害並擊倒 1 秒。', { col: '#ff6a4a', el: null }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    // 孫堅「赤幘」：原地留替身，自己隱身
    decoy(u, a, X) {
      const s = this.spawnMinion(u.team, null, u.x, u.y, false);
      Object.assign(s, { spec: u.spec, image: true, summon: true, owner: u, temp: X.life, still: true, ms: 0, atk: 0, maxHp: u.maxHp * 0.3, hp: u.maxHp * 0.3, r: 22, name: u.name, f: u.f });
      u.st.invis = Math.max(u.st.invis, X.dur);
      this.fx({ k: 'puff', x: u.x, y: u.y });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 江東猛虎：生命高於 70% 時加攻擊（每 0.5 秒重算）
    hook('tick', 30, function (u, dt) { const g = u.sg; if (g && g.tiger && (u.oldT = (u.oldT || 0) - dt) <= 0) { u.oldT = 0.5; this.addBuff(u, { id: 'tiger', t: 0.8, atk: u.hp > u.maxHp * 0.7 ? g.tiger.v('atk') : 0 }); } }),
  ],
  // 電腦什麼時候放這招
  ai: {
    decoy: ({ w, u, t, d, hero, hpR, foeHeroes }) => hpR < 0.35 && foeHeroes(500) > 0,
  },
});
